import { apiClient } from "../Config/ApiClient";

export const retrieveAdvertise = (token) => apiClient.get(`/advertisement`, { headers: {'Authorization': token }})